import { LegacyPortalSearchEventType } from "@spwn-portal/grpc/build";

export const EVENT_TYPE_DATA = [
  {
    id: LegacyPortalSearchEventType.VENUE,
    label: "event",
  },
  {
    id: LegacyPortalSearchEventType.STREAMING,
    label: "stream",
  },
] as const;
